<template lang="pug">
InheritWrapper(v-model="inherit" :readonly="innerSetting.ReadOnly || disabled")
  BriqIsoDurationInput.mb-S(
    :label="innerSetting.DisplayName"
    :help="innerSetting.Description"
    :disabled="innerSetting.ReadOnly || disabled ? true : inherit"
    :hideOptionalMarker="true"
    :required="this.$attrs.required"
    :error="fieldError"
    :monthsVisible="true"
    :yearsVisible="true"
    v-model="innerValue"
  )
</template>

<script>
import InheritWrapper from '@v/settings/application/advanced/InheritWrapper.vue'
import setupInheritedField from './setupInheritedField.js'
import BriqIsoDurationInput from '@/vue/components/BriqIsoDurationInput.vue'
import { toRefs, computed } from '@vue/composition-api'
import mixin from '@v/settings/application/advanced/mixin.js'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Duration',
  components: { InheritWrapper, BriqIsoDurationInput },
  mixins: [mixin],
  props: {
    setting: {
      type: Object,
      required: true,
    },
    disabled: Boolean,
  },
  validations() {
    return {
      innerValue: {
        required,
        $each: {
          required,
        },
      },
    }
  },
  setup: (props, { emit }) => {
    const fields = setupInheritedField({ props, emit })
    return {
      ...toRefs(fields),
      type: computed(() => (props.setting.DataType === 'String' ? 'text' : 'number')),
      step: computed(() => (props.setting.DataType === 'Decimal' ? '0.01' : '1')),
    }
  },
}
</script>
